import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Tracked outbound URL for product buy buttons.
// Hits /api/products/{id}/go which logs the click and 302s to the affiliate URL.
export const buyLink = (productId, source = "site") =>
  `${API}/products/${productId}/go?source=${encodeURIComponent(source)}`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ef_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default client;
